// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"2281a058","237":"67406bb0","393":"cebc2cf7","397":"6a292a8d","455":"37113f78","472":"0677d799","618":"a6c337e4","633":"d41214b9","647":"0ebbebe5"}[chunkId] + ".chunk.js";
};